var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.7134 0 0 6.71803 0 15C0 23.282 6.7134 30 15 30C23.2866 30 30 23.282 30 15C30 13.3162 28.6313 11.9512 26.943 11.9512C25.2547 11.9512 23.886 13.3162 23.886 15C23.886 19.919 19.9053 23.9025 15 23.9025C10.0947 23.9025 6.11401 19.919 6.11401 15C6.11401 10.081 10.0947 6.09755 15 6.09755C16.6883 6.09755 18.057 4.73257 18.057 3.04877C18.057 1.36498 16.6883 0 15 0Z",
    fill: "#252B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87311 15C8.87311 18.3861 11.6162 21.1311 15 21.1311C18.3838 21.1311 21.1269 18.3861 21.1269 15C21.1269 11.6139 18.3838 8.86889 15 8.86889C11.6162 8.86889 8.87311 11.6139 8.87311 15Z",
    fill: "#252B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncLogo);
export default __webpack_public_path__ + "static/media/inc-logo.84f45a4b918156d098103fcd000edfbf.svg";
export { ForwardRef as ReactComponent };